import { BulkResizeEditorOperationValue, BulkResizeEditorOperation } from "store/features/bulkResize/types";

export const getFlipRotateData = (
    operations: BulkResizeEditorOperation[],
): {
    rotation: number;
    flipH: boolean;
    flipV: boolean;
} => {
    let rotation = 0,
        flipH = false,
        flipV = false;

    operations.forEach((operation) => {
        const name = operation.name;

        if (name === "flip") {
            const { value } = operation.value as BulkResizeEditorOperationValue["flip"];

            if (value == "horizontal") {
                flipH = !flipH;
            } else {
                flipV = !flipV;
            }

            return;
        }

        if (name === "rotate") {
            const value = operation.value as BulkResizeEditorOperationValue["rotate"];

            let _rotation = rotation;

            if (value.direction === "clock-wise") {
                _rotation = (_rotation + 90) % 360;
            } else {
                _rotation = (_rotation - 90) % 360;
            }

            if (value.flip.horizontal && value.flip.vertical) {
                if (value.direction === "clock-wise") {
                    _rotation = (_rotation + 180) % 360;
                } else {
                    _rotation = (_rotation - 180) % 360;
                }

                flipH = !flipH;
                flipV = !flipV;
            } else if (value.flip.horizontal || value.flip.vertical) {
                if (value.flip.horizontal) {
                    if (value.flip.horizontal === flipH) {
                        flipH = false;
                        flipV = true;
                    } else if (value.flip.horizontal === flipV) {
                        flipH = true;
                        flipV = false;
                    }
                } else {
                    if (value.flip.vertical === flipV) {
                        flipV = false;
                        flipH = true;
                    } else if (value.flip.vertical === flipH) {
                        flipV = true;
                        flipH = false;
                    }
                }
            }

            rotation = _rotation;

            return;
        }
    });

    return {
        rotation,
        flipH,
        flipV,
    };
};
